import type { PrintoutColumnType } from "../types";
import { isPivotActive } from "./isPivotActive";

interface IsMergeSimilarActiveArgs {
	mergeSimilarShiftTimes: boolean | undefined;
	columnGroupingBy: PrintoutColumnType | null | undefined;
	rowGroupingBy: PrintoutColumnType[];
}

/**
 * `mergeSimilarShiftTimes` only fires inside horizontal-pivot mode, and only when shift time
 * is involved as either the pivot axis or a row-grouping anchor (mapping §11.4).
 *
 * Outside pivot mode the flag is a no-op (mapping notes this is intentional — section grouping
 * by shift time has its own §6.3 proximity merge; sheet split by shift time has its own §7.2
 * overlap merge). Single source of truth so every layer agrees on when to apply the alias map.
 */
export const isMergeSimilarActive = (args: IsMergeSimilarActiveArgs): boolean => {
	const { mergeSimilarShiftTimes, columnGroupingBy, rowGroupingBy } = args;
	if (!mergeSimilarShiftTimes) return false;
	if (!isPivotActive(columnGroupingBy)) return false;
	return columnGroupingBy === "shiftTime" || rowGroupingBy.includes("shiftTime");
};
